import api from './api';

export const getServiceRolesApi = (params) => api().get('/service-permissions', { params });
export const addNewServiceRoleApi = (data) => api().post('/service-permissions', data);
export const deleteServiceRolesApi = (params) => api().delete('/service-permissions', { params });
export const updateServiceRolesApi = (params) => api().patch(`/service-permissions/${params.id}`, params.values);
